import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const taskStoppageManager = {
  taskStoppage(url: string) {
    return axiosInstance.v2({
      url: url,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

export default taskStoppageManager;
